/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateContentFilePiece {
    getFixupPrototypeFunction() { return TemplateContentFilePiece.fixupPrototype; }

    static newInstance(model: Partial<TemplateContentFilePiece>): TemplateContentFilePiece {
        let obj = Object.assign(new TemplateContentFilePiece(), model);
        TemplateContentFilePiece.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateContentFilePiece>): TemplateContentFilePiece {
        if (!model) return null;
        return TemplateContentFilePiece.newInstance(<TemplateContentFilePiece> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateContentFilePiece) {
        if (!obj) return;

        models.TemplateContentFilePiece.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateContentFilePiece): boolean {
        Object.setPrototypeOf(obj, TemplateContentFilePiece.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Filename, e.g. 'main.tf'
     */
    name: string;

    /**
     * Raw file content
     */
    content: string;

}
